import { Star, StarHalf, StarOff } from 'lucide-react';

const StarRating = ({ rating = 5 }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="flex items-center space-x-1 text-yellow-400">
      {[...Array(fullStars)].map((_, i) => (
        <Star key={`full-${i}`} fill="currentColor" stroke="currentColor" size={18} />
      ))}
      {halfStar && <StarHalf fill="currentColor" stroke="currentColor" size={18} />}
      {[...Array(emptyStars)].map((_, i) => (
        <StarOff key={`empty-${i}`} size={18} />
      ))}
    </div>
  );
};

export default StarRating;
